import React from 'react';
import { Button, LocalVehicle } from '..';
import { TranslationUtils } from '../../utils';

interface VehicleActionPanelProps {
    myGroupHasNoVehicleRef: React.MutableRefObject<any>;
    myGroupHasNoVehicle: boolean;
    vehicles: LocalVehicle[];
    vehiclesAllowed: number;
    onMyGroupHasNoVehicleChange: (e: any) => void;
    onMyGroupHasNoVehicleLabelClick: () => void;
    onAddVehicleClick: () => void;
}

export const VehicleActionPanel: React.FC<VehicleActionPanelProps> = (props) => {
    const { myGroupHasNoVehicle, onMyGroupHasNoVehicleChange, onMyGroupHasNoVehicleLabelClick, vehicles } = props;
    const { myGroupHasNoVehicleRef, onAddVehicleClick, vehiclesAllowed } = props;

    return (
        <div className="row">
            <div className="col-6 col-md-6">
                <div className="form-check vertical-center-checkbox">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={myGroupHasNoVehicle}
                        onChange={onMyGroupHasNoVehicleChange}
                        ref={myGroupHasNoVehicleRef}
                    />
                    <label id="label-no-vehicles" className="form-check-label small" onClick={onMyGroupHasNoVehicleLabelClick}>
                        {TranslationUtils.get('group_has_no_vehicles')}
                    </label>
                </div>
            </div>
            {vehicles.length === 0 && (
                <div className="col-6 col-md-6">
                    <div className="col-8 float-right">
                        <Button
                            id={'vehicle-add-button'}
                            className="vehicle-large-button"
                            variant="primary"
                            label={TranslationUtils.get('add_a_vehicle_button')}
                            onClick={onAddVehicleClick}
                        />
                    </div>
                </div>
            )}
            <div className="col-6 col-md-6">
                {vehicles.length > 0 && vehicles.length < vehiclesAllowed && (
                    <span id="link-add-vehicle" className="float-right pointer span-margin" onClick={onAddVehicleClick}>
                        {`+ ${TranslationUtils.get('add_a_vehicle_button')}`}
                    </span>
                )}
                {vehicles.length >= vehiclesAllowed && (
                    <p className="small text-danger max-message float-right">{TranslationUtils.get('max_vehicles_reached')}</p>
                )}
            </div>
        </div>
    );
};
